export enum EclassWorkerEnum {
  All = null,
  Daily = 1,
  Activity = 2,
  Announcement = 3,
  Live = 4,
  CpbProvas = 5,
  // Sequence = 6,
}
